// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Products_KvResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response for GET /so/products/kv — returns key-value list for dropdowns.
 *
 * @see Products_KvOptionRow
 */
import type { Products_KvOptionRow } from './Products_KvOptionRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Products_KvResponseDados = Products_KvOptionRow[];

export type Products_KvResponse = ApiResponse<Products_KvResponseDados>;

registerResponseContract('Products_KvResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      value: { type: 'number',  required: true },
      label: { type: 'string',  required: true },
    },
  },
})
